// covered-by: frontends/carrie/src/ask-v2/review/__tests__/AskV2ReviewCommentsList.test.tsx
import { type ReactNode } from "react";

import { CommentSectionBody } from "../../routes/ask-puntt/components/AssetViewerPane";

type AskPunttReviewCommentBodyProps = {
  commentId: string;
  description: string;
  afterExpand?: ReactNode;
};

export function AskPunttReviewCommentBody({
  commentId,
  description,
  afterExpand,
}: AskPunttReviewCommentBodyProps) {
  return (
    <CommentSectionBody
      commentId={commentId}
      description={description}
      clampCommentSections={false}
      slotAfterExpand={afterExpand}
    />
  );
}
